<nav class="lm-nav" aria-label="Main">
  <div class="lm-nav__group">
    <a class="lm-nav-link" routerLink="/today" routerLinkActive ariaCurrentWhenActive="page">
      <svg lucideSun class="lm-icon"></svg>
      <span class="lm-nav-link__label">Today</span>
    </a>
    <a class="lm-nav-link" routerLink="/focus" routerLinkActive ariaCurrentWhenActive="page">
      <svg lucideTarget class="lm-icon"></svg>
      <span class="lm-nav-link__label">Focus</span>
    </a>
  </div>
  <div class="lm-nav__group">
    @if (auth.isAuthenticated()) {
      <app-running-pill />
      <div #menuAnchor class="lm-menu-anchor">
        <button
          #avatarBtn
          type="button"
          class="lm-avatar-btn"
          aria-haspopup="menu"
          [attr.aria-expanded]="menuOpen()"
          aria-label="Account and settings"
          title="Account and settings"
          (click)="toggleMenu()">
          <span class="lm-avatar" aria-hidden="true">{{ userInitial() }}</span>
          @if (menuOpen()) {
            <svg lucideChevronUp class="lm-icon lm-icon--sm"></svg>
          } @else {
            <svg lucideChevronDown class="lm-icon lm-icon--sm"></svg>
          }
        </button>
        @if (menuOpen()) {
          <ul class="lm-menu" role="menu" aria-label="Account and settings">
            @if (signedInName(); as name) {
              <li class="lm-menu__header" role="presentation">Signed in as {{ name }}</li>
            }
            <li role="none">
              <a
                class="lm-menu__item"
                role="menuitem"
                tabindex="-1"
                routerLink="/activities"
                (click)="closeMenu(false)">
                <svg lucideList class="lm-icon"></svg>
                Activities
              </a>
            </li>
            <li role="none">
              <a
                class="lm-menu__item"
                role="menuitem"
                tabindex="-1"
                routerLink="/settings"
                (click)="closeMenu(false)">
                <svg lucideSettings class="lm-icon"></svg>
                Settings
              </a>
            </li>
            <li class="lm-menu__separator" role="separator"></li>
            <li role="none">
              <button
                type="button"
                class="lm-menu__item"
                role="menuitem"
                tabindex="-1"
                (click)="signOut()">
                <svg lucideLogOut class="lm-icon"></svg>
                Sign out
              </button>
            </li>
          </ul>
        }
      </div>
    } @else {
      <a class="lm-nav-link" routerLink="/login" routerLinkActive ariaCurrentWhenActive="page">
        <svg lucideLogIn class="lm-icon"></svg>
        <span class="lm-nav-link__label">Sign in</span>
      </a>
    }
  </div>
</nav>
<main>
  <router-outlet />
</main>
